<template>
  <div class="blog-filters">
    <button
      v-for="(item, index) in items"
      :key="index"
      class="item"
      @click="clicked(item)"
    >
      <div class="square" :class="{ selected: isSelected(item) }">
        <i class="icon-check"></i>
      </div>
      <span>{{ item.name }}</span>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: ""
    },
    unique: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    isSelected(item) {
      return this.value.split(",").includes(`${item.id}`);
    },
    clickedUnique(item) {
      if (this.value === `${item.id}`) {
        this.$emit("input", "");
      } else {
        this.$emit("input", `${item.id}`);
      }
    },
    clicked(item) {
      if (this.unique) {
        this.clickedUnique(item);
        return;
      }
      const selected = this.value.split(",");
      if (selected.includes(`${item.id}`)) {
        selected.splice(selected.indexOf(`${item.id}`), 1);
        this.$emit("input", selected.join(","));
      } else {
        this.$emit("input", [...selected, item.id].join(","));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.blog-filters {
  .item {
    display: flex;
    align-items: center;
    padding: 8px 0;
    background: transparent;
    border: none;
    color: white;
    text-align: left;

    .square {
      outline: 1px solid rgba(210, 208, 216, 1);
      border-radius: 4px;
      background: transparent;
      padding: 0;
      max-width: 20px;
      max-height: 20px;
      min-width: 20px;
      min-height: 20px;
      margin-right: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      color: white;

      i {
        display: none;
      }

      &.selected {
        outline: none;
        background: linear-gradient(
            90deg,
            rgba(180, 4, 8, 0.2) 0%,
            rgba(16, 12, 61, 0.2) 70%,
            rgba(16, 12, 61, 1) 95%,
            rgba(16, 16, 16, 1) 100%
          ),
          linear-gradient(
            180deg,
            rgba(16, 16, 16, 1) 0%,
            rgba(16, 12, 61, 1) 100%
          );

        i {
          display: block;
        }
      }
    }
  }
}
</style>
